import { ExchangeRateContent } from "../../components/configuration";

export default function ExchangeRate() {
  return (
    <>
      <ExchangeRateContent />
    </>
  );
}
